
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import EditBrandModal from './components/EditBrandModal.vue';
import DetailsBrandModal from './components/DetailsBrandModal.vue';
import { Brand } from '@/models/brand.model';
import { KeyObject } from '@/common/interface';
import {
  AuthEnum,
} from '@/services/permission.service';
import GiftDays from './components/GiftDays.vue';
import UploadModal from './components/UploadModal.vue';
import SpuService from '@/services/spu.service';
import InvoiceDrawer from './components/InvoiceDrawer.vue';
import RecordingDrawer from './components/RecordingDrawer.vue';
import RecordingChainDrawer from './components/RecordingChainDrawer.vue';


@Component({
  components: {
    'edit-brand-modal': EditBrandModal,
    'detail-brand-modal': DetailsBrandModal,
    'gift-days': GiftDays,
    'upload-modal': UploadModal,
    'invoice-drawer': InvoiceDrawer,
    RecordingDrawer,
    RecordingChainDrawer,
  },
})
export default class BrandList extends Vue {
  AuthEnum = AuthEnum;
  @Ref('giftDays')
  giftDays!: GiftDays;

  @lazyInject(SpuService)
  protected spuService!: SpuService;

  @Ref('recordingDrawer')
  recordingDrawer!: RecordingDrawer;

  @Ref('recordingChainDrawer')
  recordingChainDrawer!: RecordingChainDrawer;

  @Ref('uploadModal')
  uploadModal!: UploadModal;

  @Ref('invoiceDrawer')
  invoiceDrawer!: InvoiceDrawer;

  menuPermissions: KeyObject<boolean> = {};

  listData: Brand[] = [];

  pagination = {
    total: 0,
    pageSize: 10,
    current: 1,
    onChange: this.paginationChange,
  };

  form: any = {
    kaName: '',
    brandCode: '',
  };

  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      align: 'center',
      width: 100,
    },
    {
      title: '品牌名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      align: 'center',
      width: 160,
    },
    {
      title: 'brandcode',
      dataIndex: 'brandcode',
      key: 'brandcode',
      align: 'center',
      width: 180,
    },
    {
      title: '品牌logo',
      dataIndex: 'logo',
      key: 'logo',
      ellipsis: true,
      scopedSlots: { customRender: 'logo' },
      align: 'center',
      width: 160,
    },
    {
      title: '头图',
      dataIndex: 'headlineImage',
      key: 'headlineImage',
      ellipsis: true,
      scopedSlots: { customRender: 'headlineImage' },
      align: 'center',
      width: 160,
    },

    {
      title: '服务商名称',
      dataIndex: 'serviceProvider',
      key: 'serviceProvider',
      ellipsis: true,
      align: 'center',
      width: 160,
    },
    {
      title: '是否自动提现',
      dataIndex: 'autoWithdrawl',
      key: 'autoWithdrawl',
      align: 'center',
      width: 80,
    },
    {
      title: '主账号',
      dataIndex: 'primaryAccount',
      key: 'primaryAccount',
      ellipsis: true,
      align: 'center',
      width: 180,
    },
    {
      title: '品牌管理员',
      dataIndex: 'brandAdmin',
      key: 'brandAdmin',
      align: 'center',
      width: 180,
    },
    {
      title: '门店数量',
      dataIndex: 'shopNum',
      key: 'shopNum',
      ellipsis: true,
      align: 'center',
      width: 100,
    },
    {
      title: '是否系统对接',
      dataIndex: 'isLinked',
      key: 'isLinked',
      ellipsis: true,
      align: 'center',
      width: 100,
    },
    {
      title: '保护规则',
      dataIndex: 'protection',
      key: 'protection',
      ellipsis: true,
      align: 'center',
      width: 100,
    },

    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
      width: 160,
    },
    {
      title: '品牌类型',
      dataIndex: 'brandType',
      key: 'brandType',
      align: 'center',
      width: 160,
      customRender: (text: any) => {
        let _text = '高德KA';
        if (text === 1) {
          _text = '高德KA';
        } else {
          _text = '小规模连锁';
        }
        return _text;
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 240,
    },
  ];

  @Ref('editBrandModal')
  editBrandModal!: EditBrandModal;

  @Ref('detailBrandModal')
  detailBrandModal!: DetailsBrandModal;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Watch('$route')
  async handleSearch() {
    const { page, pageSize, kaName, brandCode } = this.$route.query;

    const query: any = {
      pageSize: pageSize || 10,
      page: page || 1,
    };
    if (kaName) {
      query.kaName = kaName;
      this.form.kaName = kaName;
    }
    if (brandCode) {
      query.brandCode = brandCode;
      this.form.brandCode = brandCode;
    }
    await this.list(query);
  }

  openInvoiceDrawer(row: any) {
    this.invoiceDrawer.open(row);
  }

  openRecordingDrawer(row: any) {
    if (row.brandType === 2) {
      this.recordingChainDrawer.open(row);
    } else if (row.brandType === 1) {
      this.recordingDrawer.open(row);
    }
  }

  funGiftDays(row: any) {
    this.giftDays.init(row);
  }
  funUploadModal(val: any) {
    this.uploadModal.init(val);
  }
  async onCopySuccess(val: any) {
    const _url = await this.spuService.getRule('ka_shop_join_info_url');
    const textarea = document.createElement('textarea');
    textarea.value = `${_url}/${val.id}`;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.$message.success('复制成功');
  }
  oepnEditBrandModal() {
    this.editBrandModal.open('');
  }

  accountAlbumTemplate(currentBrand: any) {
    const routeUrl = this.$router.resolve({
      name: 'account.album-template',
      params: {
        ka_id: currentBrand!.id,
      },
      query: {
        kaName: currentBrand!.name,
      },

    });
     window.open(routeUrl.href, '_blank');
  }

  changeBrand(val: any) {
    this.editBrandModal.open(JSON.parse(JSON.stringify(val)));
  }

  openDetailBrandModal(val: any) {
    this.detailBrandModal.open(JSON.parse(JSON.stringify(val)));
  }

  paginationChange(current: number) {
    this.pagination.current = current;
    // const query = this.extractRouterQueryAndFillFilterForm();
    // Object.assign(query, { page: current });
    const { kaName, brandCode } = this.form;
    const query: any = {
      page: current,
      timestamp: Math.round(Date.now() / 1000),
    };
    if (kaName) {
      query.kaName = kaName;
    }
    if (brandCode) {
      query.brandCode = brandCode;
    }
    this.$router.push({ query });
  }

  async list(params: { pageSize?: number; page: number }) {
    const res = await this.brandService.list(params);
    if (res) {
      this.listData = res.list.map((data: any) => {
        return Brand.from(data);
      });

      this.pagination = {
        total: res.total,
        current: res.page,
        pageSize: Number(res.pageSize),
        onChange: this.paginationChange,
      };
    }
  }

  /**
   * 页面刷新
   */
  refresh() {
    this.pagination = {
      total: 0,
      pageSize: 10,
      current: 1,
      onChange: this.paginationChange,
    };
    this.form = {
      kaName: '',
      brandCode: '',
    };

    this.$router.push({
      query: {},
    });
  }

  async created() {
    this.$nextTick(async () => {
      await this.handleSearch();
    });
  }

  go(routeName: string): void {
    this.$router.push({ name: routeName });
  }

  search() {
    const { kaName, brandCode } = this.form;
    const query: any = {
      page: 1,
      timestamp: Math.round(Date.now() / 1000),
    };
    if (kaName) {
      query.kaName = kaName;
    }
    if (brandCode) {
      query.brandCode = brandCode;
    }
    this.$router.push({
      query,
    });
  }

  resetQuery() {
    this.form = {
      kaName: '',
      brandCode: '',
    };
    const query: any = {
      page: 1,
      timestamp: Math.round(Date.now() / 1000),
    };
    this.$router.push({ query });
  }
}
